export default __webpack_public_path__ + "static/media/whatsapp-intro.7d4c7b31.png";